export interface ITopic {
  title: string
  description: string
}

export const topicsData: ITopic[] = [
  {
    title: 'Space Race: Colonization or Decentralization?',
    description:
      'Phase Four’s Margaret Abernathy, Relativity Space’s Josh Brost, and Space Perspective’s Jane Poynter join this panel to discuss the evolving objectives and logistics of space missions, weighing the prospects of colonization against the broader vision of decentralization. Discover the challenges, opportunities and innovations that are shaping the future of our cosmic endeavors.',
  },
  {
    title: 'The Transition to New Energy',
    description:
      'Explore the challenges, innovations, and opportunities presented by the transition to new energy sources. FreeWire’s Arcady Sosinov joins Cathryn Chen on stage to discuss the role of technology and investment in shaping a greener future.',
  },
  {
    title: 'The Future of Interaction',
    description:
      "With insights from DIH Management's Jason Chen, Discord's Sumeet Vaidya, and Nex's Alex Wu, this panel will explore the technologies and trends redefining the boundaries of virtual engagement. Whether it's the rise of immersive virtual spaces, the challenges of fostering community online, or the tools that will shape the future of remote work and play, join us for a deep dive into the future of interaction.",
  },
  {
    title: 'Generative AI: Revolution or Hype?',
    description:
      'A thought-provoking discussion that delves into the world of generative AI, as industry pioneers weigh in on its revolutionary promise versus the surrounding hype. With insights from Instabase’s Anant Bhardwaj, Alison AI’s Asaf Yanai, FuriosaAI’s June Paik, and Coframe’s Josh Payne, this panel seeks to demystify the capabilities and limitations of generative AI.',
  },
  {
    title: 'Geopolitical Arbitrage',
    description:
      'As nations grapple with changing alliances, economic policies, and technological advancements, opportunities for arbitrage emerge. Our distinguished panelists — Dr. Tony Chan of KAUST and Howard Morgan of B Capital — will discuss strategies to capitalize on these shifts, the risks involved, and the future of investing in a multipolar world where geopolitics plays an increasingly pivotal role in shaping markets.',
  },
  {
    title: 'Electrification of Everything? Next Gen EV Transportation',
    description:
      'Blake Scholl, Founder & CEO of Boom Supersonic, Sampriti Bhattacharyya, Co-founder & CEO at Navier, Monika Mikac, Ex-COO of Rimac and now CEO at NAD Capital, and Ed Ludlow from Bloomberg Technology, come together to shed light on the next generation of electric vehicles and the broader implications for our world. From supersonic air travel to cutting-edge marine vehicles and beyond, this panel will delve into the challenges, breakthroughs, and the transformative potential of electrifying every mode of transport.',
  },
  {
    title: 'Blockchain Infrastructure',
    description:
      'LayerZero’s Irene Wu joins Algorand’s Ryan Terribilini in exploring the interoperability of blockchains, the tokenization of real assets, and a more inclusive, decentralized, and borderless on-chain global economy.',
  },
]
